import options from './sticky.directive';

export default {
    selector: 'dtSticky',
    options
};



// WEBPACK FOOTER //
// ./app/common/sticky/index.js